import React, {SyntheticEvent, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
// Design.
import {
    AlertTypes,
    apiClient,
    BaseCrudClient,
    enumNamesToSelect,
    GenericFormContainer,
    Grid,
    IAlertData,
    Leap4Breadcrumbs,
    Mode,
    SelectForObject, setAlert,
    Spinner,
    MuiIcons,
    FormControl,
    TextField,
    Typography,
    Toc as TocIcon,
    Create as CreateIcon,
    GpsFixed as GpsFixedIcon
} from "@leap4/frontend";
// Logic.
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {AdServerTagSideEnum, IDataPoint, INetworkPartner, PartnerSideEnum} from "@leap4/entities-discrepancy-common";
import {
    baseBackendRoute,
    dataPointsUrl,
    ManualAliasLinkedTagsURL,
    UpdateManualAlias
} from "../../../../../config/generals";
import {urlService} from "../../../../routing/urlsService";
import { styles } from "./style";
import {DataPointOrphanTags} from "./DataPointOrphanTags";
import {ManualAliasLinkedTags} from "./ManualAliasLinkedTags";
import {useQuery} from "react-query";
import {RootState} from "../../../../../interfaces/root-state.interface";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../../shared/OneOrgOnly/OneOrgOnly";

const {Face: FaceIcon, AutoFixNormal: AutoFixNormalIcon} = MuiIcons;


const {add, deleteInstance, getById} = BaseCrudClient;

interface IFormData extends Partial<INetworkPartner> {
}
const mapStateToProps = (state: RootState) => ({});

const mapActions = {
    setAlert
}

const connector = connect(mapStateToProps, mapActions);

type PropsFromRedux = ConnectedProps<typeof connector>;

export interface IReduxAlertProps extends PropsFromRedux {
    setAlert: (alert: IAlertData) => void
}

const _AddEditAlias = (props: IReduxAlertProps): JSX.Element => {
    const {setAlert} = props
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const dispatch = useDispatch();
    const [chosenOrphanRowsIds, setChosenOrphanRowsIds] = useState([]);
    const [chosenLinkedRowsIds, setChosenLinkedRowsIds] = useState([]);

    const schemaName = "networkPartner";
    const addInstanceRoute = `/${schemaName}s/add`;
    const editInstanceRoute = `/${schemaName}s/`;
    const PartnerSideSelect = enumNamesToSelect(PartnerSideEnum, undefined, undefined, 'Side')
    const [isAddPage, setIsAddPage] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [dataPoints, setDataPoints] = useState<Array<IDataPoint>>([]);
    const [triggerDataRefresh, setTriggerDataRefresh] = useState(false)

    const [entity, setInstance] = useState<IFormData>({companyId: '0', name: "", dataPoint: {name: "", id: ""}, side: AdServerTagSideEnum.SUPPLY});

    const handleFormChange = (e: any) => {
        let {name, value} = e.target;
        setInstance({...entity, [name]: value});
    }

    const deleteFunc = async () => {
        await deleteInstance(String(params.id), schemaName, history, dispatch, baseBackendRoute)
    }

    const saveAlias = async () =>{
        if (isAddPage) {
            const newAlias = (await add<any>({
                ...entity,
                partner: null,
                isManualCreated: true
            }, schemaName, null, dispatch, baseBackendRoute)).data;
            if (chosenOrphanRowsIds.length) {
                const res = await apiClient.post(ManualAliasLinkedTagsURL, {
                    networkPartner: newAlias,
                    orphanTagsIds: chosenOrphanRowsIds
                })
            }
            setChosenOrphanRowsIds([])
            setTriggerDataRefresh(!triggerDataRefresh)
            history.push(`/partners/alias/${newAlias._id}`)
        } else if (params.id && params.id != "add") {
            const updatedAlias = (await apiClient.patch(`${UpdateManualAlias}/${params.id}`, entity)).data
            if (chosenOrphanRowsIds.length || chosenLinkedRowsIds.length) {
                const res = await apiClient.post(ManualAliasLinkedTagsURL, {
                    networkPartner: entity,
                    orphanTagsIds: chosenOrphanRowsIds,
                    linkedTagsIds: chosenLinkedRowsIds
                })
                setChosenOrphanRowsIds([])
                setTriggerDataRefresh(!triggerDataRefresh)
            }
        }
    }

    const handleSubmit = async (ev: SyntheticEvent) => {
        // For block rendering.
        if(!entity || !entity.side || !entity.dataPoint.id || !entity.name) return setAlert({msg: 'Please Enter All Fields', type: AlertTypes.WARNING})
        await refetchSubmit()
    };

    const handleDatapointChange = (e) => {
        const dp = dataPoints.find(datapoint => datapoint._id === e.target.value)
        setInstance({
            ...entity, dataPoint: {
                id: dp._id as string,
                name: dp.name
            }
        })
    }

    const fetchInitialData = async () => {
        const id = params.id;
        let dataPointsData: IDataPoint[] = await (await apiClient.get(dataPointsUrl)).data.results;
        if (id && id !== "add") {
            setIsAddPage(false);
            const instanceData = await getById(id, schemaName, dispatch, baseBackendRoute);
            setInstance({...instanceData});

        } else {
            setInstance({
                name: "",
            })
        }
        setDataPoints(dataPointsData)
    }

    const {isLoading: isLoadingSubmit, refetch: refetchSubmit } = useQuery(
        'save-alias-query',
        saveAlias,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        }

    )

    const {isLoading: isLoadingDelete, refetch: refetchDelete} = useQuery(
        'delete-alias-query',
        deleteFunc,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    const {isLoading: isLoadingInitialData, refetch: refetchInitialData} = useQuery(
        'fetch-price-rule-data-query',
        fetchInitialData,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });

    useEffect(() => {
        refetchInitialData()
    }, [params.id]);

    useEffect(()=>{
    setIsLoading( isLoadingSubmit || isLoadingInitialData || isLoadingDelete)
    },[isLoadingSubmit, isLoadingInitialData, isLoadingDelete])

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Leap4Breadcrumbs
                breadcrumbs={[
                    {
                        text: "Partners Dashboard",
                        icon: <TocIcon/>,
                        link: urlService.partnersDemand()
                    },
                    {
                        text: "Aliases",
                        icon: <FaceIcon/>,
                        // link: urlService.partnersDemand()
                    },
                    {
                        text: isAddPage ? "Create" : "Update",
                        link: isAddPage ? addInstanceRoute : editInstanceRoute,
                        icon: isAddPage ? <CreateIcon/> : <AutoFixNormalIcon/>
                    },
                    {
                        text: entity.name,
                        link: "",
                        icon: <GpsFixedIcon/>
                    }
                ]}
            />
            <GenericFormContainer mode={isAddPage ? Mode.Create : Mode.Edit}
                                  onCreateOrEditFunc={handleSubmit}
                                  disabled={isLoading}
                                  style={{height: '400px', padding: '20px', margin: "35px 25px", borderRadius: "16px"}}
                                  onDeleteFunction={deleteFunc}>


                {isLoading ? <Spinner/> : <form style={styles.form} noValidate onSubmit={handleSubmit}>
                    <Grid direction={"column"} container alignItems={"flex-start"}>
                        <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                                {params.id ? 'Update' : 'Add'} Alias
                            </Typography>
                        </Grid>
                        <Grid item container width={"50%"} marginTop={"2vh"} gap={2}>
                            <TextField
                                disabled={isLoading}
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Name"
                                name="name"
                                autoComplete="name"
                                autoFocus
                                onChange={handleFormChange}
                                value={entity?.name}
                            />
                            <FormControl variant="outlined" style={styles.formControl}>
                                <PartnerSideSelect
                                    disabled={Boolean(params.id)}
                                    label={'Side'}
                                    required
                                    fullWidth
                                    value={entity?.side || ""}
                                    onChange={handleFormChange}
                                    name="side"/>
                            </FormControl>
                            <FormControl variant="outlined" style={styles.formControl}>
                                <SelectForObject title="DataPoint" items={dataPoints}
                                                 valueKey={"_id"} labelKey={"name"}
                                                 value={entity.dataPoint?.id || ""}
                                                 onChange={handleDatapointChange}
                                                 disabled={Boolean(params.id)}
                                                 label="DataPoint"
                                                 name="dataPoint"/>
                            </FormControl>
                        </Grid>
                    </Grid>
                </form>}
            </GenericFormContainer>
            <Grid container gap={2} alignItems={'center'} justifyContent={'center'}>
                <Grid item lg={params.id? 5.5 : 12}>
                    <DataPointOrphanTags triggerDataRefresh={triggerDataRefresh} setChosenRowsIds={setChosenOrphanRowsIds}
                                         side={entity.side} dataPointId={entity.dataPoint?.id}
                                         setIsLoading={setIsLoading} isLoading={isLoading}/>
                </Grid>
                {
                    params.id &&
                    <Grid item lg={5.5}>
                    <ManualAliasLinkedTags setChosenLinkedIds={setChosenLinkedRowsIds} triggerDataRefresh={triggerDataRefresh} isLoading={isLoading}
                                           setIsLoading={setIsLoading} networkPartnerId={params.id}/>
                </Grid>}
            </Grid>

        </>
    );
}

export const AddEditAlias = connector(_AddEditAlias)
